// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"1868ea65","351":"ba9e343a","500":"f060f25f","528":"ee0c3a61","558":"90719cff","757":"94678c25","889":"05963f74"}[chunkId] + ".chunk.js";
};